import Navbar from '../layout/navbar/Navbar';
import Sidebar from '../layout/navbar/Sidebar';
import Footer from '../layout/footer/Footer';

export default function Admin(props) {
    return (
        <>
            <div className='rtl'>
                <header>
                    <Navbar />
                </header>

                <div className='space-120' />

                <div className='d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block'>
                    <Sidebar />
                </div>

                <div className='main-content'>
                    {props.children}

                    <div className='space-20' />

                    <hr />

                    <Footer />
                </div>
            </div>
        </>
    );
}
